"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconSVGFilter = exports.Wrapper = exports.Value = exports.Label = exports.Icon = exports.Ctas = exports.Copy = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _index = require("../../../../utilities/index");
var _LexusTypography = require("../../../LexusTypography");
var _breakpoints = _interopRequireDefault(require("../../../breakpoints"));
var BaseStyles = _interopRequireWildcard(require("../index.styled"));
const Container = exports.Container = _styledComponents.default.div`
  ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "body14"
})}
  display: flex;
  flex-direction: column;
  flex: 1 1 calc(100% - 16px);
  max-width: calc(100% - 16px);

  ${(0, _breakpoints.default)("tablet", "up")} {
    flex: 1 1 calc(50% - 16px);
    max-width: calc(50% - 16px);
  }
`;
const Wrapper = exports.Wrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: row;
  gap: 60px 16px;
`;

/**
 * Adds a filter to Icon component svgs
 *
 * @param svgFilter css filter
 * @returns svg with filter value
 */
const iconSVGFilter = function (svgFilter) {
  if (svgFilter === undefined || !svgFilter) return "";
  return `
    svg {
      filter: ${svgFilter};
    }
  `;
};
exports.iconSVGFilter = iconSVGFilter;
const Icon = exports.Icon = _styledComponents.default.div`
  max-width: 72px;
  width: 100%;

  ${function (_ref) {
  let {
    $svgFilter
  } = _ref;
  return $svgFilter && iconSVGFilter($svgFilter);
}}
`;
const Copy = exports.Copy = _styledComponents.default.div`
  display: flex;
  flex-direction: column;

  gap: 16px;
  text-align: left;
`;
const Label = exports.Label = (0, _styledComponents.default)(BaseStyles.Label)`
  min-height: 24px;
  ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "subheading20"
})}
  color:
  ${function (_ref2) {
  let {
    $textColor
  } = _ref2;
  return $textColor ? (0, _index.colorToAlphaHex)($textColor, 0.7) : "#000000b2";
}};

  ${(0, _breakpoints.default)("desktop", "up")} {
    min-height: 30px;
    ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "heading24"
})}
  }
`;
const Value = exports.Value = (0, _styledComponents.default)(BaseStyles.Value)`
  min-height: 24px;
  ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "subheading20",
  spacing: "0.8px"
})}
  ${function (_ref3) {
  let {
    $textColor
  } = _ref3;
  return $textColor && `color: ${$textColor}`;
}};

  ${(0, _breakpoints.default)("desktop", "up")} {
    min-height: 30px;
    ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "heading24",
  spacing: "0.96px"
})}
  }
`;
const Ctas = exports.Ctas = (0, _styledComponents.default)(BaseStyles.Ctas)`
  padding: 0;
`;